import ReportsView from "../../components/reports/ReportsView";
import { downloadViaBrowser } from "../../lib/utils";
import { INITIAL_REPORT_FILTERS } from "../../lib/constants";

export function ReportsPage({
  activeReportTab,
  agents,
  context,
  currentUser,
  exportingReport,
  geographyData,
  loadingReports,
  reportData,
  reportDraftFilters,
  reportFilters,
  roleScope,
  setActiveReportTab,
  setExportingReport,
  setNotice,
  setReportDraftFilters,
  setReportFilters,
  updateReportDraftFilter,
  resetReportFilters,
}) {
  function handleReportDownload(format) {
    setExportingReport(true);

    try {
      const params = new URLSearchParams({
        format,
        period: reportFilters.period,
      });
      if (reportFilters.dateFrom) {
        params.set("date_from", reportFilters.dateFrom);
      }
      if (reportFilters.dateTo) {
        params.set("date_to", reportFilters.dateTo);
      }
      if (reportFilters.sourceId) {
        params.set("source", reportFilters.sourceId);
      }
      if (reportFilters.region) {
        const exportRegionParts = reportFilters.region
          .split(",")
          .map((r) => r.trim())
          .filter(Boolean);
        const exportRealRegions = exportRegionParts.filter((r) => r !== "Other Cities");
        const exportHasOther = exportRegionParts.includes("Other Cities");
        if (exportRealRegions.length > 0) {
          params.set("region", exportRealRegions.join(","));
        }
        if (exportHasOther) {
          const otherCityNames = (geographyData && geographyData.otherCities) || [];
          if (otherCityNames.length > 0) {
            params.set("city", otherCityNames.join(","));
          }
        }
      }
      if (roleScope?.scope === "own_leads") {
        params.set("assigned_to", String(currentUser.id));
      } else if (reportFilters.assignedToId) {
        params.set("assigned_to", reportFilters.assignedToId);
      }
      // Reports are B2C-only
      params.set("campaign_type", "b2c");
      setNotice(`Starting ${format.toUpperCase()} export.`);
      downloadViaBrowser(`/api/crm/reports/funnel/export/?${params.toString()}`);
    } finally {
      setExportingReport(false);
    }
  }

  return (
    <ReportsView
      activeReportTab={activeReportTab}
      agents={agents}
      context={context}
      exporting={exportingReport}
      loading={loadingReports}
      onDownloadReport={handleReportDownload}
      onReportDraftChange={updateReportDraftFilter}
      onReportFilterReset={() => {
        setReportDraftFilters(INITIAL_REPORT_FILTERS);
        setReportFilters(INITIAL_REPORT_FILTERS);
      }}
      reportData={reportData}
      reportDraftFilters={reportDraftFilters}
      roleScope={roleScope}
      setActiveReportTab={setActiveReportTab}
    />
  );
}

export default ReportsPage;
